import { isNativeApp } from './isNativeApp';

const EVENT_NAME = 'sp:native-debug';
const MAX_EVENTS = 20;

function getStore() {
  if (typeof window === 'undefined') return null;
  if (!window.__SP_NATIVE_DEBUG__) {
    window.__SP_NATIVE_DEBUG__ = { events: [] };
  }
  return window.__SP_NATIVE_DEBUG__;
}

export function emitNativeDebugEvent(detail) {
  if (!isNativeApp()) return;
  if (typeof window === 'undefined') return;

  const payload = {
    ts: Date.now(),
    ...detail
  };

  const store = getStore();
  if (store) {
    store.events.unshift(payload);
    store.events = store.events.slice(0, MAX_EVENTS);
  }

  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));
  } catch {
    // no-op
  }
}

export function getNativeDebugEvents() {
  const store = getStore();
  return store?.events || [];
}

function safeUrl(rawUrl) {
  if (!rawUrl) return '';
  try {
    const u = new URL(rawUrl, window.location.href);
    u.search = '';
    u.hash = '';
    return u.toString();
  } catch {
    return String(rawUrl);
  }
}

export function normalizeAxiosError(err) {
  const cfg = err?.config;
  const method = (cfg?.method || 'GET').toUpperCase();
  const url = safeUrl(cfg?.url);

  const status = err?.response?.status;
  const data = err?.response?.data;
  const detail =
    (typeof data === 'string' ? data : data?.detail) ||
    err?.message ||
    'Errore di rete';

  const code = err?.code;

  return {
    kind: 'axios',
    method,
    url,
    status,
    code,
    detail
  };
}

export const NATIVE_DEBUG_EVENT_NAME = EVENT_NAME;
